import { Epic, StateObservable, ofType } from 'redux-observable';
import { Action, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@store/create-store';
import { Dependencies } from '@configurations/dependencies/dependencies';
import { Observable, catchError, concatMap, from, mergeMap, of } from 'rxjs';
import { ToastNotification } from '@scenario/models/toast-notification.model';
import { displayToast } from '@store/toast-notifications/toast-notifications-slice';
import {
  unsubscribeToPriceCardFailure,
  unsubscribeToPriceCardSuccess,
} from '@store/price-card/subscription/subscription.slice';


export const unsubscribeToPriceCardByIdEpic: Epic<Action, Action, RootState, Dependencies> = (
  action$: Observable<Action>,
  _state$: StateObservable<RootState>,
  dependencies: Dependencies,
) =>
  action$.pipe(
    ofType('price-card-subscriptions/unsubscribeToPriceCard'),
    concatMap((action: PayloadAction<number>) =>
      from(dependencies.priceCardSubscriptionGateway.unsubscribeById(action.payload)).pipe(
        mergeMap(() => {
          const toastNotification: ToastNotification = {
            title: 'Unsubscription',
            content: 'Successfully unsubscribed to price card',
            status: 'info',
            closeIconButtonLabel: 'close',
            reference: dependencies.idProvider.generate(),
          };
          return of(unsubscribeToPriceCardSuccess(action.payload), displayToast(toastNotification));
        }),
        catchError(() => of(
          unsubscribeToPriceCardFailure('Unable to unsubscribe to price card'),
          displayToast({
            title: 'Unsubscription',
            content: 'unable to unsubscribe to this price card',
            status: 'danger',
            closeIconButtonLabel: 'close',
            reference: dependencies.idProvider.generate(),
          }),
        ),),
      ),
    ),
  );
